var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-6 col-lg-4"},[_c('router-link',{attrs:{"to":_vm.partnerId ? { name: 'shops', query: { categoryId: _vm.categoryId } } : '#'}},[_c('div',{staticClass:"home-categorie-item",style:(_vm.style),on:{"click":_vm.onClick}},[_c('h3',[_vm._v(_vm._s(_vm.nom))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }